import { render, staticRenderFns } from "./DevolucaoImpropria.vue?vue&type=template&id=14ff925c&scoped=true&"
import script from "./DevolucaoImpropria.vue?vue&type=script&lang=js&"
export * from "./DevolucaoImpropria.vue?vue&type=script&lang=js&"
import style0 from "./DevolucaoImpropria.vue?vue&type=style&index=0&id=14ff925c&scoped=true&lang=css&"
import style1 from "./DevolucaoImpropria.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ff925c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
